<template>
  <form @submit.prevent="onLogin" class="p-4 rounded bg-light shadow-sm">
    <h2 class="mb-3 text-center">Iniciar sesión</h2>
    <div class="mb-3">
      <input v-model="email" type="email" class="form-control" placeholder="Email" required />
    </div>
    <div class="mb-3">
      <input v-model="password" type="password" class="form-control" placeholder="Contraseña" required />
    </div>
    <button class="btn btn-primary w-100" type="submit">Entrar</button>
    <div v-if="error" class="alert alert-danger mt-2 py-1 px-2 text-center">{{ error }}</div>
  </form>
</template>

<script>
import api from "../api/api";
export default {
  data() {
    return { email: "", password: "", error: "" };
  },
  methods: {
    async onLogin() {
      try {
        const res = await api.login(this.email, this.password);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        if (res.data.user.role === "superadmin") this.$router.push("/admin");
        else this.$router.push("/user");
      } catch {
        this.error = "Credenciales inválidas";
      }
    },
  },
};
</script>
